// extracted by mini-css-extract-plugin
export default {"footer":"styles_footer__eBn66","controls":"styles_controls__VMwgu","even":"styles_even__C+KEw"};